import { prefersReducedMotion } from '@/utils/motion';

export const reveal = {
  mounted(el, binding) {
    el.classList.add('reveal');
    const { delay = 0, threshold = 0.2 } = binding.value ?? {};
    if (delay) el.style.setProperty('--reveal-delay', `${delay}ms`);
    if (prefersReducedMotion()) {
      el.classList.add('reveal-in');
      return;
    }
    const observer = new IntersectionObserver(
      (entries, obs) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          el.classList.add('reveal-in');
          obs.unobserve(el);
        });
      },
      { threshold, rootMargin: '0px 0px -8% 0px' },
    );
    observer.observe(el);
    el.__revealObserver = observer;
  },
  unmounted(el) {
    el.__revealObserver?.disconnect();
  },
};
